import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private Environment:'Local'|'Production'|'Stage' = "Stage"; //Production,Stage,Local

  private EnvironmentObject = {
    "Local" : {
       apiUrl:'http://localhost:3002/'
      //apiUrl:'https://real-tires-train.loca.lt/'
    },
    "Stage" : {
    // apiUrl:"http://13.234.47.193:3004" 
      apiUrl:location.origin + "/"
    },
    "Production" : {
      // apiUrl:"http://localhost:3001"
      apiUrl:location.origin + "/"

    }
  }
  constructor() {
    if (location.origin.includes("localhost")) {
      this.Environment = 'Local';
    } else {
      this.Environment = 'Production';
    }

  }

  getBaseUrl(){
    return this.EnvironmentObject[this.Environment]['apiUrl']
    // return this.EnvironmentObject[this.Environment]['apiUrl']+'/'
  }
}
